<!-- @format -->

@for (item of studySelectionItems; track calculateItemId($index, item); let isFirst = $first; let isLast = $last) {
  <div [attr.id]="calculateItemId(0, item)" data-cy="study-selection-item" class="study-selection-item">
    <div class="move-buttons" data-cy="move-attainment-buttons">
      @if (!isFirst) {
        <sis-button
          data-cy="move-attainment-up"
          (clicked)="move(item.ordering, true)"
          (mouseover)="addHoverStyles(item)"
          (mouseleave)="removeHoverStyles(item)"
          [link]="true"
          [attr.aria-label]="'ARIA_LABEL.MOVE_ATTAINMENT_UP' | translate">
          <sis-icon icon="sorter"></sis-icon>
        </sis-button>
      }
      @if (!isLast) {
        <sis-button
          data-cy="move-attainment-down"
          (clicked)="move(item.ordering, false)"
          (mouseover)="addHoverStyles(item)"
          (mouseleave)="removeHoverStyles(item)"
          [link]="true"
          [attr.aria-label]="'ARIA_LABEL.MOVE_ATTAINMENT_DOWN' | translate">
          <sis-icon icon="sorter" [iconClass]="'flip-180'"></sis-icon>
        </sis-button>
      }
    </div>
    @if (item.type === "Attainment") {
      <sis-attainment-tree-attainment
        [attainment]="item.attainment"
        [attainmentsById]="indexedAttainments.byId"
        [selectedLocale]="selectedLocale">
      </sis-attainment-tree-attainment>
    }
    @if (item.type === "GroupingModuleLike") {
      <sis-editable-attainment-tree-grouping-module
        [moduleSelection]="getValidModuleSelection(item.studySelection)"
        [moduleContent]="moduleContent"
        [indexedAttainments]="indexedAttainments"
        [courseUnitsById]="courseUnitsById"
        [modulesById]="modulesById"
        (childrenUpdated)="onChildrenUpdated()"
        [selectedLocale]="selectedLocale"
        [collapsedByGroupingModuleId]="collapsedByGroupingModuleId"
        [groupingModuleVisibilityToggled]="groupingModuleVisibilityToggled">
      </sis-editable-attainment-tree-grouping-module>
    }
  </div>
}
